import React from "react"
import { Field, Form } from "react-final-form"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { IconButton, MuiIcon, TextField, Tooltip } from "@cirrus/ui-kit-ts"

import { IPostComment } from "../types/IPostComment"

interface IProps {
  lockText?: string
  onSend: (comment: IPostComment) => void
  placeholder?: string
}

export const CommentForm = ({ onSend, placeholder, lockText }: IProps) => {
  const { i18n } = useTranslations()

  return <Form
    initialValues={{ [FormField.comment]: "" }}
    onSubmit={(values, { reset }) => {
      onSend({ text: values[FormField.comment] })
      reset()
    }}
    render={({ handleSubmit, form }) => (
      <form onSubmit={handleSubmit} style={{ display: "grid" }}>
        <Field name={FormField.comment}>
          {({ input }) => {
            return (
              <Tooltip title={lockText}>
                <TextField
                  {...input}
                  multiline
                  disabled={!!lockText}
                  maxRows={3}
                  fullWidth
                  width="100%"
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      if (event.ctrlKey) {
                        form.change(FormField.comment, input.value + "\n")
                        return
                      }

                      event.preventDefault()
                      handleSubmit()
                    }
                  }}
                  placeholder={placeholder ?? `${i18n("User.Import.Label:Message")}...`}
                  endAdornment={
                    <IconButton
                      size="small"
                      title={i18n("General:Send")}
                      disabled={input.value?.trim().length === 0 || !!lockText}
                      onClick={handleSubmit}
                    >
                      <MuiIcon.Send />
                    </IconButton>
                  }
                />
              </Tooltip>
            )
          }}
        </Field>
      </form>
    )}
  />
}

enum FormField {
  comment = "comment"
}
